import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { approveDiscount, clearAllNotifications, clearSingleNotification, getUserNotifications, rejectDiscount } from '../../redux/features/student/studentSlice'
import { ProcessingButton } from '../../shared/ProcessingButton'
import AppContext from '../../storage/AppContext'
import Header from '../header/Header'
import useToast from '../../shared/Toast'
import "./index.css"
import { Spinner } from 'react-bootstrap'
import {MdRefresh} from "react-icons/md"
import { approveTemplate, rejectTemplate } from '../../redux/features/template/templateSlice'
import * as constants from '../../config/config'
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import { Button } from 'react-bootstrap';



const ShowTemplateComponent = ({showTemplateModal, setShowTemplateModal, templateModalDetails}) => {
  return(
      <Modal  size='lg' fullscreen={true} show={showTemplateModal} onHide={() => { setShowTemplateModal(!showTemplateModal)}}  scrollable>
          <Modal.Header closeButton></Modal.Header>
          <div className='p-3'>
              {templateModalDetails ?
              <>
              {templateModalDetails?.editedTitle ?
                <div className='d-flex'>
                  <div className='w-50'>
                    <h3>Original Template</h3>
                    <br/>
                    <div className='template-card-notification'>
                      <h4 className='mb-2'>{templateModalDetails?.title}</h4>
                      <span >{parse(templateModalDetails?.message)}</span>
                    </div>
                  </div>
                  <div className='w-50'>
                    <h3>Edited Template</h3>
                    <br/>
                    <div className='template-card-notification'>
                    <h4 className='mb-2'>{templateModalDetails?.editedTitle}</h4>
                    <span>{parse(templateModalDetails?.editedMessage)}</span>
                    </div>
                  </div>
                </div> :
                <div className='p-3'>
                <h4 className='mb-2'>{templateModalDetails?.title}</h4>
                <span >{parse(templateModalDetails?.message)}</span>
                </div>
              }</>:
              <h2 className='text-center'>No Details</h2>
              }
          </div>
          <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowTemplateModal(false) }}>
                    Cancel
                </Button>
            </Modal.Footer>
      </Modal>
  )
}

function Notifications() {
  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [templateModalDetails,setTemplateModalDetails] = useState({});
  const [notificationType, setNotificationType] = useState(constants.templateApproval)

  const notificationDetails = useSelector(state => state?.student?.notificationDetails?.notifications)
  const notificationDetailsStatus = useSelector(state => state?.student?.notificationDetails?.status)
  const approveDiscountDetails = useSelector(state => state.student.approveDiscountDetails)
  const rejectDiscountDetails = useSelector(state => state.student.rejectDiscountDetails)
  const clearSingleNotificationDetails = useSelector(state => state.student.clearSingleNotificationDetails)
  const clearAllNotificationsDetails = useSelector(state => state.student.clearAllNotificationsDetails)

  const approveTemplateDetails = useSelector(state => state?.template?.approveTemplateDetails)
  const rejectTemplateDetails = useSelector(state => state?.template?.rejectTemplateDetails)

  const filteredNotificationDetails = notificationDetails.filter(each => each.type === notificationType)
   
  const appContext = useContext(AppContext);

  const userDetails = appContext?.userDetails

  const dispatch = useDispatch()
  const showToast = useToast()

  const notificationsIds = []
  notificationDetails?.map(eachNotification => {
    if(!eachNotification?.type){
      notificationsIds.push(eachNotification.id)
    }
  })

  useEffect(() => {
    if (approveDiscountDetails.status === "succeeded") {
        setTimeout(() => {
            window.location.reload()
        }, 2500)
        showToast({ message: approveDiscountDetails.message })
    }
    if(approveDiscountDetails.status === "failed"){
        showToast({message: approveDiscountDetails.message, type: 'error'})
    }
  },[approveDiscountDetails])

  useEffect(() => {
    if (rejectDiscountDetails.status === "succeeded") {
        setTimeout(() => {
            window.location.reload()
        }, 2500)
        showToast({ message: rejectDiscountDetails.message })
    }
    if(rejectDiscountDetails.status === "failed"){
        showToast({message: rejectDiscountDetails.message, type: 'error'})
    }
  },[rejectDiscountDetails])

  useEffect(() => {
    if(clearSingleNotificationDetails.status === "succeeded"){
      setTimeout(() => {
        window.location.reload()
      }, 2500)
      showToast({ message: clearSingleNotificationDetails.message })
    }if(clearSingleNotificationDetails.status === "failed"){
      showToast({message: clearSingleNotificationDetails.message, type: 'error'})
    }
  },[clearSingleNotificationDetails])

  useEffect(() => {
    if(clearAllNotificationsDetails.status === "succeeded"){
      setTimeout(() => {
        window.location.reload()
      }, 2500)
      showToast({ message: clearAllNotificationsDetails.message })
    }if(clearAllNotificationsDetails.status === "failed"){
      showToast({message: clearAllNotificationsDetails.message, type: 'error'})
    }
  },[clearAllNotificationsDetails])

  useEffect(() => {
    if (approveTemplateDetails.status === "succeeded") {
        setTimeout(() => {
            window.location.reload()
        }, 2500)
        showToast({ message: approveTemplateDetails.message })
    }
    if(approveTemplateDetails.status === "failed"){
        showToast({message: approveTemplateDetails.message, type: 'error'})
    }
  },[approveTemplateDetails])

  useEffect(() => {
    if (rejectTemplateDetails.status === "succeeded") {
        setTimeout(() => {
            window.location.reload()
        }, 2500)
        showToast({ message: rejectTemplateDetails.message })
    }
    if(rejectTemplateDetails.status === "failed"){
        showToast({message: rejectTemplateDetails.message, type: 'error'})
    }
  },[rejectTemplateDetails])

  const onClickApprove = (term,discount,id,admissionNumbers,admissions, academicYear) => {
        console.log("term discount", term , discount, id, admissionNumbers, admissions)
        const branch = userDetails?.data?.branch
        const role = userDetails?.data?.role
        dispatch(approveDiscount({term, discount, branch, role, id, admissionNumbers, admissions, academicYear}))
  }

  const onClickReject = (term,discount,id,admissionNumbers,admissions,academicYear) => {
    console.log("term discount", term , discount, id, admissionNumbers)
        const branch = userDetails?.data?.branch
        const role = userDetails?.data?.role
        dispatch(rejectDiscount({term, discount, branch, role, id, admissionNumbers, admissions, academicYear}))
  }

  const onClickRefresh = () => {
    const branch = userDetails?.data?.branch
    const role = userDetails?.data?.role
    dispatch(getUserNotifications({branch, role}))
  }

  const onClickClearSlingleNotification = (eachNotification) => {
      const branch = userDetails?.data?.branch
      const role = userDetails?.data?.role
      dispatch(clearSingleNotification({notificationId:eachNotification.id,branch,role}))
  }

  const onClickClearAllNotifications = () => {
      const branch = userDetails?.data?.branch
      const role = userDetails?.data?.role
      dispatch(clearAllNotifications({notificationsIds, branch, role}))
  }

  const onClickTemplateApprove = (id,templateDetails) => {
    const branch = userDetails?.data?.branch
    const role = userDetails?.data?.role
    dispatch(approveTemplate({notificationId:id,templateDetails,branch,role}))
  }

  const onClickTemplateReject = (id,templateDetails) => {
    const branch = userDetails?.data?.branch
    const role = userDetails?.data?.role
    dispatch(rejectTemplate({notificationId:id,templateDetails,branch,role}))
  }

  const onClickview = (templateDetails) => {
    console.log("templafmkandnf",templateDetails)
    setShowTemplateModal(true)
    setTemplateModalDetails(templateDetails)
  }

  return (
    <>
    <Header />
    {showTemplateModal && <ShowTemplateComponent showTemplateModal={showTemplateModal} setShowTemplateModal={setShowTemplateModal} templateModalDetails={templateModalDetails}/>}
    <div className='d-flex justify-content-between mt-2 mb-2 px-5'>
          <div>
          <button className='btn btn-info mr-2' onClick={() => setNotificationType(constants.templateApproval)}>Templates Notifications</button>
          <button className='btn btn-info' onClick={() => setNotificationType(constants.discountApproval)}>Discount Notifications</button>
          </div>
          <button className='btn btn-dark mr-2' onClick={() => {onClickRefresh()}}><MdRefresh size={24} className='pb-1'/> Refresh</button>
          {/* <button className='btn btn-danger' disabled={notificationsIds.length === 0} onClick={() => {onClickClearAllNotifications()}}>Clear All</button> */}
    </div>

    {filteredNotificationDetails?.length > 0 ?
    (
      (approveTemplateDetails?.status === 'loading' || rejectTemplateDetails?.status === 'loading' || approveDiscountDetails?.status === 'loading' || rejectDiscountDetails?.status === 'loading' || notificationDetailsStatus === 'loading' || clearSingleNotificationDetails.status === 'loading' || clearAllNotificationsDetails.status === 'loading') ? 
      
          (<div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
                <Spinner animation="border" role="status"></Spinner>
          </div>)
      : (
        <>

      <div className='d-flex flex-column px-5'>
        {filteredNotificationDetails?.map(eachNotification => {
            return(
              <div className='notification-container'>
                <h5  className='message'>{eachNotification.message}</h5>
                {eachNotification.type === "discountApproval" &&
                    <div>
                      <button className='btn btn-primary ml-2' onClick={() => {onClickApprove(eachNotification.term,eachNotification.discount,eachNotification.id,eachNotification.admissionNumbers,eachNotification.admissions, eachNotification.academicYear)}}>Approve</button>
                      <button className='btn btn-danger ml-2' onClick={() => {onClickReject(eachNotification.term,eachNotification.discount,eachNotification.id,eachNotification.admissionNumbers,eachNotification.admissions, eachNotification.academicYear)}}>Reject</button>
                    </div>}

                {eachNotification.type === "templateApproval" && 
                <div>
                  <button className='btn btn-warning' onClick={() => {onClickview(eachNotification.templateDetails)}}>View</button>
                  {eachNotification.status === constants.pending &&
                  <>
                  <button className='btn btn-primary ml-2' onClick={() => {onClickTemplateApprove(eachNotification.id,eachNotification.templateDetails)}}>Approve</button>
                  <button className='btn btn-danger ml-2' onClick={() => {onClickTemplateReject(eachNotification.id,eachNotification.templateDetails)}}>Reject</button>
                  </>
                  }
                </div>}
                
                {/* {eachNotification.type !== "discountApproval" && eachNotification.type !== 'templateApproval' &&<button className='btn btn-outline-danger' onClick={() => {onClickClearSlingleNotification(eachNotification)}}>Clear</button>} */}
              </div>
            )
        })}
    </div>
    </>)
    ):
    (
        <h5 className='text-center mt-5'>No Notifications To Show</h5>
    )}
    </>
  )
}

export default Notifications